import React from 'react';
import { connect } from 'react-redux';
import { is, compose } from 'ramda';
import { List, Map } from 'immutable';

import styleFile from './AvailHotelDetail.js';
import { RichText, Link, Button, Image } from '@synergycms_core/components/generic/';
import Stars from '../../components/functional/Stars/index';
import AmenitiesList from '../../components/functional/AmenitiesList';
import Price from '@synergycms_core/components/generic/Price';
import { getDistance, formatNumber, checkAvailSegments, round,getUniqueRef } from '../../utils/utils';
import ModalMedia from '../../components/functional/ModalMedia/ModalMedia.jsx';
import { AD_BOARD, AD_BOARD_BUFFET, PROPERTY_MANAGEMENT_GROUP } from '../../config/constants';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import actions from '../../store/actions';
import { validateAsyncComponent } from '../../components/HoC';
import { formatPrice } from '../../utils/priceFormatter.js';

const HotelInfoLink = props => (
  <div className={[props.classes.infoButton,!props.hotel.get('slug') ? props.classes.hideSlug : undefined].join(' ')}>
    <Link
      richText={{
        innerStyle: ['fontSize13', 'block', 'toggleMainLinkReverse'],
        translate: true,
        text: '_%+ info%_'
      }}
      title={' '}
      innerStyle={['fontSize13', 'block', 'toggleMainLinkReverse']}
      href={props.hotel.get('slug')}
      target={'_blank'}
    />
  </div>
);

const HotelImage = props => (
  <div className={props.classes.positionImage} ref={props.setInnerRef}>
    <HotelDiscountImage discount={props.discount} classes={props.classes} />
    <Image
      innerStyle={'backgroundImageBase'}
      alt={props.hotel.get('name')}
      /*backgroundImage={
        process.env.NODE_ENV === 'development'
          ? 'https://edge.media.datahc.com/HI378221428.jpg' + (props.resizableImages && props.width ? props.width : '')
          : props.hotel.get('default_photo') + (props.resizableImages && props.width ? props.width : '')
      }*/
      src={
        process.env.NODE_ENV === 'development'
        ? 'https://edge.media.datahc.com/HI378221428.jpg' + (props.resizableImages && props.width ? props.width : '')
        : props.hotel.get('default_photo') + (props.resizableImages && props.width ? props.width : '')
      }
      loading={'lazy'}
    />
  </div>
);

const HotelOpinions = props => (
  <div className={[props.classes.column33, props.classes.alignRight].join(' ')}>
    <RichText
      innerStyle={[props.classes.multiHotelOpinion]}
      icon={{
        content: '',
        innerStyle: ['']
      }}>
      {props.hotel.get('avg_opinions')}
    </RichText>
    <RichText innerStyle={[props.classes.roboto13Gray]}>
      {props.hotel.get('total_opinions')}{' '}
      <RichText translate={true} ucFirst={true}>
        _%opiniones%_
      </RichText>
    </RichText>
  </div>
);

const HotelPrice = props => (
  <div className={props.classes.centerPrice}>
    <div className={props.classes.sinceFooter}>
      <RichText innerStyle={['roboto13Gray']} ucFirst={true} translate={true}>
        _%desde%_
      </RichText>
    </div>
    <div className={props.classes.price}>
      <Price
        innerStyle={['boldPrice', 'inlineBlock', 'alignRight']}
        amount={props.bestPrice}
        hotelCurrencyCode={props.hotel.getIn(['currency', 'code'])}
        hideDecimals={true}
      />
    </div>
    <div className={props.classes.roomNight}>
      <RichText innerStyle={['inlineBlock', 'roboto13Black', 'alignRight', 'capitalize']} translate={true}>
        _%habitación%_
      </RichText>
      /
      <RichText innerStyle={['inlineBlock', 'roboto13Black', 'alignRight', 'capitalize']} translate={true}>
        _%noche%_
      </RichText>
    </div>
  </div>
);

const HotelNextStep = props => (
  <div className={props.classes.seeRoms}>
    <Button
      innerStyle={['toggleMainButton']}
      onClick={props.onNextClick(props.hotel, props.bestPriceTax, props.hotelCode)}
      richText={{
        plural: true,
        text: '_%ver habitación%_',
        ucFirst: true,
        innerStyle: ['toggleMainButton'],
        translate: true
      }}
    />
  </div>
);

const HotelDiscountImage = props =>
  Number.isFinite(props.discount) &&
  props.discount <= -5 && (
    <div className={props.classes.discountRibbonContainer}>
      <div className={props.classes.discountRibbon}>
        <span className={props.classes.discountRibbonSpan}>
          <RichText text={props.discount + '%'} innerStyle={['roboto19White']} />
        </span>
      </div>
    </div>
  );

class AvailHotelDetail extends React.Component {
  static displayName = 'AvailHotelDetail';

  constructor(props) {
    super(props);
    this.state = {
      width:null,
    };
    this.widthRef = React.createRef();
    this.onNextClick = this.props.onNextClick.bind(this);

    const { hotel, cities, langInfo } = this.props;
    const city = hotel && cities.find(c => c.get('id') === hotel.get('city_id'));

    this.showTaxes = hotel && hotel.get('show_taxes');

    const distance =
      hotel &&
      city &&
      getDistance(
        parseFloat(city.get('latitude')),
        parseFloat(city.get('longitude')),
        parseFloat(hotel.get('latitude')),
        parseFloat(hotel.get('longitude'))
      );

    this.showMapRichText = {
      innerStyle: [styleFile.multiHotelShowMapText],
      texts: [
        {
          text: formatNumber(distance || 0, 1, langInfo.get('thousand_separator'), langInfo.get('decimal_separator')),
          translate: false
        },
        { text: ' _%km del centro%_', translate: true }
      ]
    };
  }

  componentDidMount() {
    this.getWidthComponent();
  }
  
  getWidthComponent = () => {
    if(this.widthRef.current){
      this.setState({ 
        width: this.props.theme.getDesirableWidth(this.widthRef.current.offsetWidth, this.widthRef.current.offsetHeight)
      });
    }
  }


  render() {
    const { classes } = this.props.theme.styles;
    const { 
      hotel, 
      hotelAvail, 
      onHover, 
      eventShowMapToolTip, 
      langCode, 
      bestLoyaltyPrice, 
      slide,
      noWhiteSpace = false,
      currencies,
      currentCurrencyCode,
      hotelCurrencyCode,
      customerCountry
    } = this.props;
    
    if(!hotelAvail) return null;
    
    const bestRoom = hotelAvail.getIn([0, 'rooms', 0], Map());
    const bestBoards = bestRoom.getIn(['boards']);
    const stayLength = bestRoom.get('days').size;
    const hasFreeBreakfast = bestRoom.get('free_breakfast', false);
    let bestBoard = !hasFreeBreakfast
      ? bestBoards.first()
      : bestBoards.get(
        bestBoards.findIndex(
          b => b.get('board_code') === AD_BOARD || b.getIn([getUniqueRef(b), 'board_code']) === AD_BOARD_BUFFET
        ),
        Map()
      );

    if (!bestBoard.size) {
      bestBoard = bestBoards.get(0, Map());
    }

    
    let hasDiscountLoyalty = false;
    let bestPriceTax = bestBoard.get('price_tax') / stayLength;
    let bestPrice = bestBoard.get('price') / stayLength;
    let bestPriceDiscount = round(bestBoard.get('discount_percent'), 0);

    const {price: loyaltyBestPrice, priceTax: loyaltyBestPriceTax, discount: loyaltyBestDiscount} = bestLoyaltyPrice
    if(loyaltyBestPriceTax && loyaltyBestPriceTax < bestPriceTax){
      bestPriceTax = loyaltyBestPriceTax
      bestPrice = loyaltyBestPrice
      bestPriceDiscount = loyaltyBestDiscount
      hasDiscountLoyalty = true;
    }

    let totalAddedPrice = bestBoard.get('price_tax');
    if(hotel.get('management_group_id') === PROPERTY_MANAGEMENT_GROUP && hotel.get('summary_price_breakdown', false))
    {
      totalAddedPrice += bestBoard.get('local_taxes', List()).reduce((taxAcc, tax) =>  {
        return taxAcc + tax.get('tax_amount', 0);
      }, 0)
    }

    const hotelAmenities = hotel.get('amenities', List());
    const hotelBrand = hotel.get('brand');
    const categoryType = hotel.get('category_type', 'default');

    return (
      this.props.hotelAvail &&
      this.props.hotel && (
        <div
          onMouseEnter={onHover(hotel.get('id'))}
          onMouseLeave={onHover()}
          className={[classes.defaultStyle, slide ? classes.slideStyle : ''].join(' ')}>
          <HotelImage hotel={hotel} discount={bestPriceDiscount} classes={classes} width={this.state.width} setInnerRef={this.widthRef} resizableImages={this.props.theme.resizableImages}/>
          <ModalMedia mediaEntity={hotel} langCode={langCode} slide={slide} />
          <div className={hotelBrand && classes.hotelBrand}>
            {/* HOTEL BRAND */}
            {hotelBrand && <Image svg={hotelBrand+'Brand'} />}
            <div className={[classes.rowHotelContent, classes.hotelInfoContainer].join(' ')}>
              <div className={classes.hotelContentHeader}>
                {/* HOTEL STARS */}
                <Stars stars={hotel.get('stars')} categoryType={categoryType} />
                {/* HOTEL NAME */}
                <RichText innerStyle={['droidSerif18Black', slide ? 'hotelNameSlide' : 'hotelName']}>{hotel.get('name')}</RichText>
                {/* HOTEL ADDRESS */}
                <RichText innerStyle={['roboto13Gray', 'block', 'truncateText']}>
                  {hotel.get('address')}. {hotel.get('city')}
                </RichText>
                {/* HOTEL LOCATION */}
                <Button innerStyle={classes.seeMap} onClick={eventShowMapToolTip(hotel.get('id'))} ariaLabel={hotel.get('name')}>
                  {this.showMapRichText.texts.map((element, index) => (
                    <RichText
                      key={element.text}
                      text={element.text}
                      translate={element.translate}
                      innerStyle={classes.multiHotelShowMapText}
                      iconPosition={index === 0 ? this.showMapRichText.iconPosition : undefined}
                      icon={index === 0 ? this.showMapRichText.icon : undefined}
                    />
                  ))}
                </Button>
              </div>
              {/* HOTEL OPINIONS */}
              {hotel.get('total_opinions') > 0 && <HotelOpinions hotel={hotel} classes={classes} />}
            </div>
            <div className={[classes.rowHotelContent, classes.listContainer, slide ? classes.listContainerSlide : ''].join(' ')}>
              {hotelAmenities.size > 0 && (
                <AmenitiesList maxAmenities={4} list={hotelAmenities} innerStyle={['multiHotelAmenities', noWhiteSpace ? 'noWhiteSpace' : '']} />
              )}
            </div>
            <div className={[classes.rowHotelContent, classes.footerContainer].join(' ')}>
              {/* HOTEL BEST PRICE ROOM/NIGHT */}
              <HotelPrice hotel={hotel} bestPrice={this.showTaxes ? bestPriceTax : bestPrice} classes={classes} />
              {/* HOTEL INFO LINK */}
              <HotelInfoLink hotel={hotel} classes={classes} />
              {/* MONO HOTEL LINK */}
              <HotelNextStep
                hotel={hotel}
                onNextClick={this.onNextClick}
                bestPriceTax={bestPriceTax}
                hotelCode={hotel.get('code')}
                classes={classes}
              />
              {hasDiscountLoyalty && <div className={classes.textLoyalty} >
                <RichText 
                  innerStyle={['roboto13Gray', 'capitalize'].join(' ')} 
                  text={'_%portal descuento fidelizacion%_'} 
                  ucFirst={true}
                  translate={true}/>
              </div>}
              {hotel.get('management_group_id') === PROPERTY_MANAGEMENT_GROUP && hotel.get('summary_price_breakdown', false) && (
              <div className={[classes.multiHotelTaxes]}>
                <RichText 
                  text={'_%{totalPrice} total con tasas y fees%_'}
                  translate={true}
                  withVars={{
                    totalPrice: formatPrice(totalAddedPrice, { 
                      currencies, 
                      currentCurrencyCode, 
                      hotelCurrencyCode,
                      customerCountry
                    })
                  }} />
              </div> 
            )}
            </div>
          </div>
        </div>
      )
    );
  }
}



const mapDispatchToProps = (dispatch) => {
  return {
    onNextClick: (hotel, bestPriceTax, hotelCode) => e => {
      e.preventDefault();
      dispatch(actions.events.trigger('multiavail_book', { hotelCode, bestPriceTax }));
      dispatch(actions.app.goToMonoHotelAsync(hotel.get("id")));
    }
  };
};

const mapStateToProps = (store, ownProps) => {

  const hotelInfo = store.getIn(['hotels', ownProps.hotelId]),
    hotelAvail = store.getIn([
      'avail',
      ownProps.hotelId,
      store.getIn(['hotels', ownProps.hotelId, 'params', store.getIn(["availQuery", "multi", "base_query_params"])]),
      'raw_response'
    ]),
    cities = store.getIn(['hotels', 'hotels_info', 'cities']);

    
    const bestLoyaltyPrice = {
      price : 0,
      priceTax: 0,
      discount: 0
    }
    
  return {
    hotel: is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo,
    hotelAvail: is(List, hotelAvail) && hotelAvail.size > 0 && checkAvailSegments(hotelAvail) && hotelAvail,
    cities: cities,
    langInfo: store.getIn(['customer', 'lang_info']),
    langCode: store.getIn(['customer', 'lang_info', 'code']),
    bestLoyaltyPrice: bestLoyaltyPrice,
    currencies: store.getIn(['customer', 'currencies']),
    currentCurrencyCode: store.getIn(['customer', 'current_currency']) || undefined,
    customerCountry: store.getIn(['customer', 'country', 'code'], 'ES'),
    hotelCurrencyCode:
      ownProps.hotelCurrencyCode ||
      store.getIn(['hotels', store.getIn(['customer', 'current_hotel']), 'currency', 'code']) || // Monohotel
      (store.get('hotels').find((v, k) => Number.isFinite(+k)) || Map()).getIn(['currency', 'code']), // Multihotel
    };
};


export const AvailHotelDetailMulti =  compose(
  validateAsyncComponent(mapStateToProps),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withThemeJSS({ styleFile : styleFile({enable901:true}), displayName:"AvailHotelDetailMulti", link: true })
)(AvailHotelDetail);

export const AvailHotelDetailNoAvail =  compose(
  validateAsyncComponent(mapStateToProps),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withThemeJSS({ styleFile: styleFile({enable901:false}), displayName:"AvailHotelDetailNoAvail", link: true })
)(AvailHotelDetail);
